import { compileProductsGA4, compileProducts } from '@analytic/utils'
import { storage } from '@utils/session-storage'
import { STATUS_CART, SEND_EVENT } from '@/js/analytics/const'

export default function analyticCartView(products) {
  console.log('analyticCartView', products)
  if (!window.is_analytic_enabled) return

  window.dataLayer = window.dataLayer || []

  const objectsList = compileProductsGA4(products)

  window.dataLayer.push({
    ecommerce: {
      currency: window.currency_code,
      items: objectsList,
    },
    event: 'view_cart',
  })
}

export function sendStatusCart(cart) {
  if ('undefined' === typeof window.eS) return false
  const products = compileProducts(cart.groups)
  // eslint-disable-next-line no-undef
  eS(SEND_EVENT, STATUS_CART, {
    [STATUS_CART]: products,
    GUID: cart.GUID,
  })
  return false
}
